module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11Thbs3/tc-custom/9781507300275.jpg?1737543917508",
      "alt": "This image is the cover for the book Rupert's Tales"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rupert's Tales\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A groundbreaking story that collects, commemorates, and illuminates traditional, sacred Pagan practices and beliefs in a fresh, contemporary, and whimsical style. Join Rupert the rabbit on his adventures as he sets out to discover how and why people leave their homes to celebrate seasonal holidays in the forest where he lives. As Rupert's journey unfolds throughout the seasons, he meets owls, fairies, and old friends who teach him about the Wheel of the Year. Beautifully illustrated, this book is an excellent starting point for young children being raised within the loose structure of the various Pagan traditions. You don't have to be Pagan to be enchanted by Rupert and the magick found in his tales.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kyrja\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kyrja has authored the Rupert’s Tales, Gatekeeper’s Choice, Shards of Light series, along with The Monster Got Mom titles. Tonia’s life-long labor of love is exploring and expressing the miracles that make up her world. Her work is displayed internationally.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Schiffer Publishing Ltd\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0